export const AWAITING_FEEDBACK = "waitingForCustomerFeedback";
export const COMPLEXITY = "complexity";
export const FINISHING_DATE = "estimatedFinishingDate";
export const SOLUTION_TYPE = "solutionType";
export const TAPE_USED = "tapeInUse";
export const SUPPORT_TYPE = "supportType";
